import React from "react";
import checkgif from "../../../assets/gif/successfullgif.gif";
import { useNavigate, useLocation } from "react-router-dom";

const FeeApprovalThankYouPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Optional: If you passed the type from previous page
  const type = location.state?.type || "impose";

  const getTitle = () => {
    if (type === "defaulter_approval") return "Exception Granted!";
    return "Fee Details Approved Successfully!";
  };

  const getMessage = () => {
    switch (type) {
      case "impose":
        return (
          <>
            The fee has been <strong>imposed successfully</strong>.<br />
            All selected students have been notified, and the imposed fee details are now reflected in their ledgers.
          </>
        );
      case "discount":
        return (
          <>
            The discount has been <strong>approved successfully</strong>.<br />
            The updated fee structure has been applied to the selected students.
          </>
        );
      case "defaulter_approval":
        return (
          <>
            Your approval has been <strong>recorded successfully</strong>.<br />
            The student has been granted permission to proceed with this activity.
          </>
        );
      case "schedule":
      default:
        return (
          <>
            The scheduled fee plan has been <strong>approved successfully</strong>.<br />
            All selected students have been notified, and the updated plan is now active.
          </>
        );
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        backgroundColor: "#f9f9f9",
        textAlign: "center",
        padding: "20px",
      }}
    >
      <img
        src={checkgif}
        alt="success"
        style={{ width: "120px", height: "120px", marginBottom: "20px" }}
      />
      <h2 style={{ color: "#7f56da", marginBottom: "10px" }}>
        {getTitle()}
      </h2>
      <p style={{ maxWidth: "600px", fontSize: "16px", lineHeight: "1.5" }}>
        {getMessage()}
      </p>
      {/* <button
        onClick={() => navigate("/")}
        style={{
          marginTop: "25px",
          backgroundColor: "#7F56DA",
          color: "#fff",
          border: "none",
          padding: "10px 30px",
          borderRadius: "8px",
          cursor: "pointer",
        }}
      >
        Back to Dashboard
      </button> */}
    </div>
  );
};

export default FeeApprovalThankYouPage;
